import { Base } from '@studiometa/js-toolkit';

/**
 * Style injecté dans l'iframe du bouton Gorgias.
 * @type {string}
 */
const IFRAME_STYLE = [
  'html, body, #mountHere, .frame-content { width: 100% !important; height: 100% !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; border-radius: 50% !important; }',
  '#gorgias-chat-messenger-button { position: relative !important; display: flex !important; align-items: center !important; justify-content: center !important; width: 100% !important; height: 100% !important; border-radius: 50% !important; margin: 0 !important; padding: 0 !important; overflow: hidden !important; }',
  '#gorgias-chat-messenger-button > *:not(.mx-chat-label) { position: absolute !important; inset: 0 !important; display: flex !important; align-items: center !important; justify-content: center !important; width: 100% !important; height: 100% !important; min-width: 0 !important; max-width: none !important; border-radius: 50% !important; margin: 0 !important; padding: 0 !important; transform: none !important; }',
  '#gorgias-chat-messenger-button svg, #gorgias-chat-messenger-button img { position: static !important; flex: 0 0 auto !important; }',
  '.mx-chat-label { position: absolute !important; width: 1px !important; height: 1px !important; overflow: hidden !important; clip-path: inset(50%) !important; white-space: nowrap !important; border: 0 !important; padding: 0 !important; margin: -1px !important; }',
  '[class*="messenger-button-iframe"] { max-width: none !important; box-shadow: none !important; }',
].join('');

/**
 * GorgiasChatButton component
 * Fixes the Gorgias chat button to be a perfect circle with centered icon.
 */
export default class GorgiasChatButton extends Base {
  static config = {
    name: 'GorgiasChatButton',
  };

  /**
   *
   */
  mounted() {
    this.observer = new MutationObserver(() => this.styleChatButton());
    this.observer.observe(this.$el, { childList: true, subtree: true });

    this.iframeObserver = new MutationObserver(() => this.hideLabels());
    this.onIframeLoad = () => this.styleChatButton();

    this.styleChatButton();
  }

  /**
   *
   */
  destroyed() {
    this.observer?.disconnect();
    this.iframeObserver?.disconnect();
    this.iframe?.removeEventListener('load', this.onIframeLoad);
    this.iframe = null;
  }

  /**
   * Get the button document, or null when not reachable yet.
   * @returns {Document|null}
   */
  get buttonDocument() {
    const iframe = this.$el.querySelector('iframe#chat-button');

    if (!iframe) {
      return null;
    }

    if (iframe !== this.iframe) {
      this.iframe?.removeEventListener('load', this.onIframeLoad);
      this.iframe = iframe;
      iframe.addEventListener('load', this.onIframeLoad);
    }

    try {
      return iframe.contentDocument || iframe.contentWindow?.document || null;
    } catch {
      return null;
    }
  }

  /**
   *
   */
  styleChatButton() {
    const doc = this.buttonDocument;
    const button = doc?.querySelector('#gorgias-chat-messenger-button');

    if (!button) {
      return;
    }

    if (!doc.querySelector('#mx-chat-fix')) {
      const style = doc.createElement('style');
      style.id = 'mx-chat-fix';
      style.textContent = IFRAME_STYLE;
      doc.head.append(style);
    }

    this.hideLabels();
    this.iframeObserver.observe(button, { childList: true, subtree: true });
  }

  /**
   * Flag the button children carrying a text label. A child holding no text is
   * a layer (background, icon) and must keep filling the button.
   */
  hideLabels() {
    const button = this.buttonDocument?.querySelector('#gorgias-chat-messenger-button');

    if (!button) {
      return;
    }

    for (const child of button.children) {
      const isLabel = !child.querySelector('svg, img') && child.textContent.trim().length > 0;
      child.classList.toggle('mx-chat-label', isLabel);
    }
  }
}
